<template>
    <v-expansion-panels accordion>
        <v-expansion-panel class="expansion">
            <v-expansion-panel-header v-slot="{ open }">
                <div class="col-1 colLowPadding">
                    <v-icon class="handle" color="black">mdi-sort</v-icon>
                    <v-icon v-if="!allRequiredClasses" color="error">mdi-alert-rhombus-outline</v-icon>
                </div>
                <div class="row col-10 expansionHeaderText colLowPadding" v-if="open">
                    <div class="col-12 expansionHeaderText colLowPadding">
                        <p>Edit the block.</p>
                    </div>
                </div>
                <div v-else class="row expansionHeaderText col-10 colLowPadding">
                    <div class="col-6 expansionHeaderText colLowPadding">
                        <p>Class name: {{block.className}}</p>
                    </div>
                    <div class="col-6 expansionHeaderText colLowPadding">
                        <p>Method name:
                            {{block.className == null ? '' :
                            block.methodName !== null && block.methodName !== undefined ? block.methodName :
                            blockMethods.length === 0 ? 'execute' :'No method selected'}}</p>
                    </div>
                </div>
                <div class="col-1 colLowPadding">
                    <v-btn @click="deleteBlock()" color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div class="row">
                    <b-form-group label="The name of the class" label-for="className" class="col-6 colLowPadding">
                        <b-form-select :disabled="true" id="className" v-model="block.className" :options="options"
                                       @change="blockChanged($event)"/>
                    </b-form-group>

                    <b-form-group label="The name of the method" label-for="methodName" class="col-6 colLowPadding">
                        <b-form-select id="methodName" v-model="block.methodName" :options="blockMethods"
                                       :disabled="blockMethods.length === 0"/>
                    </b-form-group>
                </div>
                <v-divider v-if="has_config"/>
                <b-form-group v-if="has_config">
                    <prism-editor emitEvents
                                  :line-numbers="true"
                                  v-model="inner_data"
                                  language="json">
                    </prism-editor>
                    <b-form-invalid-feedback :state="validateData">
                        Data is invalid.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validateData">
                        Data is okay.
                    </b-form-valid-feedback>
                </b-form-group>
                <div v-if="blockInfo !== null">
                    <v-divider/>
                    <div class="row">
                        <div class="col-4">
                            <h5>Block category info</h5>
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left" width="125px">What</th>
                                        <th class="text-left">Value</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>From software</td>
                                        <td>{{blockInfo.fromSoftwareName ? blockInfo.fromSoftwareName :'-'}}</td>
                                    </tr>
                                    <tr>
                                        <td>From version</td>
                                        <td>{{blockInfo.fromSoftwareVersion ? blockInfo.fromSoftwareVersion :'-'}}</td>
                                    </tr>
                                    <tr>
                                        <td>To software</td>
                                        <td>{{blockInfo.toSoftwareName ? blockInfo.toSoftwareName :'-'}}</td>
                                    </tr>
                                    <tr>
                                        <td>To version</td>
                                        <td>{{blockInfo.toSoftwareVersion ? blockInfo.toSoftwareVersion :'-'}}</td>
                                    </tr>
                                    <tr>
                                        <td>Groups</td>
                                        <td>
                                            <span v-for="(group, index) in blockInfo.groups">
                                                {{group}}<span v-if="index + 1 < blockInfo.groups.length">, </span>
                                            </span>
                                            {{blockInfo.groups ? '':'-'}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                        <div v-if="blockMethodsDetail.length != 0" class="col-8">
                            <h5>Block method info</h5>
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left" width="175px">Method name</th>
                                        <th class="text-left">Description</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="m in blockMethodsDetail">
                                        <td>{{m.name}}</td>
                                        <td>{{m.description}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                        <div v-if="blockInfo.requiredClasses !== null" class="col-8">
                            <h5>Required blocks</h5>
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left">Class</th>
                                        <th class="text-left">Is added</th>
                                        <th class="text-left" width="10px"/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="i in computedRequiredClasses">
                                        <td>{{i.className}}</td>
                                        <td>{{i.isAdded}}</td>
                                        <td>
                                            <v-icon v-if="!i.isAdded" color="error">mdi-alert-rhombus-outline</v-icon>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </div>
                    <v-divider/>
                    <h5>Block description</h5>
                    <div class="col-12 colLowPadding">
                        <p>{{blockInfo.description}}</p>
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
    import BlockRepository from '../../../../repositories/block.repository';
    import PrismEditor from 'vue-prism-editor';

    export default {
        components: {
            PrismEditor
        },
        data() {
            return {
                allRequiredClasses: true,
                blockMethods: [],
                blockMethodsDetail: [],
                blockInfo: null,
                inner_data: '{}',
                has_config: false,
            }
        },
        props: {
            block: {
                type: Object,
                default: {}
            },
            options: {
                type: Array,
                default: []
            },
            currentBlocks: {
                type: Array,
                default: []
            }
        },
        methods: {
            blockChanged(blockName, selectorChange = true) {
                if (!blockName) {
                    return;
                }
                if (selectorChange) {
                    this.allRequiredClasses = true;
                    this.has_config = false;
                    this.blockInfo = null;
                    this.inner_data = '{}';
                    this.blockInfo = null;
                    this.block = {};
                    this.block.className = blockName;
                }
                if (this.block.config !== undefined && this.block.config !== null) {
                    try {
                        this.inner_data = JSON.stringify(JSON.parse(this.block.config), null, 2);
                    } catch (e) {
                        this.inner_data = JSON.stringify(this.block.config, null, 2);
                    }
                    this.has_config = true;
                }
                BlockRepository.getAllMethodsForBlock(blockName).then(res => {
                    if (res.data.success) {
                        let newBlock = this.options.find((block) => block.block.className == blockName).block;

                        this.block.className = newBlock.className; // later: add version, etc.
                        this.block.type = newBlock.type;

                        if (this.block.type === 'custom') {
                            this.block.customBlockId = newBlock.customBlockId;
                        }

                        this.blockMethods = res.data.methods;

                        if (this.blockMethods.length === 0) {
                            this.block.methodName = null;
                        }
                    }
                });
                BlockRepository.getInfoForBlock(blockName).then(res => {
                    if (res.data.success && res.data.info != null) {
                        this.blockInfo = res.data.info;
                        if (this.inner_data == '{}' && res.data.info.configTemplate !== null) {
                            this.inner_data = JSON.stringify(res.data.info.configTemplate, null, 2);
                            if (this.blockInfo != null && this.blockInfo.configTemplate != null) {
                                this.block.config = this.blockInfo.configTemplate;
                            }
                            this.has_config = true;
                        }
                        this.computedRequiredClasses;
                    }
                });
                BlockRepository.getMethodsDetailForBlock(blockName).then(res => {
                    if (res.data.success) {
                        this.blockMethodsDetail = res.data.methods;
                    }
                });
            },
            dataIsValid() {
                let valid = false;
                try {
                    let json = JSON.parse(this.inner_data);
                    if (json && typeof json === "object") valid = true;
                } catch (err) {
                    window.console.log(err);
                }
                return valid;
            },
            deleteBlock() {
                this.$emit('deleteBlock');
            }
        },
        created() {
            this.blockChanged(this.block.className, false);
        },
        computed: {
            validateData() {
                return this.dataIsValid();
            },
            computedRequiredClasses() {
                let self = this;
                let allFound = true;
                if (this.blockInfo !== null && this.blockInfo.requiredClasses !== null) {
                    let list = this.blockInfo.requiredClasses.map(function (requiredClass) {
                        let row = {className: requiredClass, isAdded: false};
                        self.currentBlocks.every((block) => {
                            if (block.className === self.block.className) {
                                row = {className: requiredClass, isAdded: false};
                                allFound = false;
                                return false;
                            } else if (block.className === requiredClass) {
                                row = {className: requiredClass, isAdded: true};
                                return false;
                            }
                            return true;
                        });
                        if (row.isAdded === false) {
                            allFound = false;
                        }
                        return row;
                    });
                    this.allRequiredClasses = allFound;
                    return list;
                }
                return [];
            }
        },
        watch: {
            inner_data: function (config) {
                if (this.blockInfo != null && this.blockInfo.configTemplate != null) {
                    this.block.config = config;
                }
            },
            currentBlocks: function () {
                this.computedRequiredClasses;
            }
        }
    }
</script>

